var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "3 3 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 3.5h2v11.17l3.59-3.58L18 12.5l-6 6-6-6 1.41-1.41L11 14.67V3.5zm-8 15h18v2H3v-2z"
})));
export default SvgDownload;